import React, { Component } from 'react';
import {connect}            from 'react-redux';
import $ from 'jquery';
import { GetTimeLineHome }  from '../../../actions/timelineAction';

class feeds extends Component{

    constructor(props){
        super(props);

     this.state = {
        pagination:1,
        load:false,
        posicao0:{texto:null,pontos:null},
        posicao1:{texto:null,pontos:null},
        posicao2:{texto:null,pontos:null},
        posicao3:{texto:null,pontos:null},
        posicao4:{texto:null,pontos:null},
        posicao5:{texto:null,pontos:null},
        setTempo: 10000,
        stopTimeline: false      
     }    

    }

    renderEfeitoTimeline(acao){
        $('.feed_1, .feed_2, .feed_3, .feed_4, .feed_5, .feed_6').attr('style',`opacity:${acao}`);
    }

    componentDidMount() {

    //   this.renderEfeitoTimeline('0.1');
    //   {!this.state.load ?  
    //     setInterval(() => {
    //        this.renderTimeline()}, this.state.setTempo): ""}
     }
    
    componentWillMount() {

        this.props.GetTimeLineHome(this.props.session.turma).then((response)=>{
            this.setState({load:true});
            this.renderTimeline();
        });        
    }

    paginate (array, page_size, page_number) {
      
        --page_number; // because pages logically start with 1, but technically with 0
        return array.slice(page_number * page_size, (page_number + 1) * page_size);
      }
      

      contaPags (total, pags) {
      
        var totalPags = total/pags;
        if (total%pags) {
            totalPags = parseInt(++totalPags);
        }
        return totalPags;

      }

    renderTimeline(){

        //if(this.state.stopTimeline){
           // return true;
        //}

    //    var retornoPaginacao = this.paginate(this.props.timeline, 6, this.state.pagination);
    //       var temp =  [{tim_tur_id: 1,  tim_tur_texto: "4 avaliações de missões para a Nave no último dia", tim_tur_pontuacao: 11, tim_tur_tipo: "missao", created_at: "2018-07-16 17:13:44"},
    //                             {tim_tur_id: 41, tim_tur_texto: "4 avaliações de missões para a Nave no último dia", tim_tur_pontuacao: 12, tim_tur_tipo: "missao", created_at: "2018-07-16 17:13:44"},
    //                             {tim_tur_id: 41, tim_tur_texto: "4 avaliações de missões para a Nave no último dia", tim_tur_pontuacao: 13, tim_tur_tipo: "missao", created_at: "2018-07-16 17:13:44"},
    //                             {tim_tur_id: 41, tim_tur_texto: "4 avaliações de missões para a Nave no último dia", tim_tur_pontuacao: 14, tim_tur_tipo: "missao", created_at: "2018-07-16 17:13:44"},
    //                             {tim_tur_id: 41, tim_tur_texto: "4 avaliações de missões para a Nave no último dia", tim_tur_pontuacao: 15, tim_tur_tipo: "missao", created_at: "2018-07-16 17:13:44"},
    //                             {tim_tur_id: 41, tim_tur_texto: "4 avaliações de missões para a Nave no último dia", tim_tur_pontuacao: 16, tim_tur_tipo: "missao", created_at: "2018-07-16 17:13:44"},
    //                             {tim_tur_id: 41, tim_tur_texto: "5 avaliações de missões para a Nave no último dia", tim_tur_pontuacao: 17, tim_tur_tipo: "missao", created_at: "2018-07-16 17:13:44"},
    //                             {tim_tur_id: 42, tim_tur_texto: "7 avaliações de missões para a Nave no último dia", tim_tur_pontuacao: 18, tim_tur_tipo: "missao", created_at: "2018-07-16 17:13:44"},
    //                         ];

                    var posicao = 0;
                    var count = 0;
                    var tempo = [];
                    for (var i = 0; i < 24; i++) {
                        if (i < 6) {
                            tempo[i] = 1000;
                        } else {
                            tempo[i] = 3000;
                        }
                        
                    }

                    for (var i = 0; i < this.props.timeline.length; i++) {

                        setTimeout(() => {
                         
                            $('.feed_'+posicao).attr('style',`opacity:0.2`);

                            this.setState({[`posicao${posicao}`]:{texto:this.props.timeline[count].tim_tur_texto,pontos:this.props.timeline[count].tim_tur_pontuacao}});
                            $('.feed_'+posicao).attr('style',`opacity:0.8`);

                            posicao++;
                            count++

                            if (posicao == 6) {
                                posicao = 0;
                            }
/*
                            if ( (i+1) ==  temp.length) {
                                i = -1;
                                posicao = 0;
                                count = 0;
                            }
*/
                        }, tempo[i] * i);



                    }


     //       }
  

        //this.renderEfeitoTimeline('0.1');

        //[0,1,2,3,4,5].map((elem,i)=>{this.setState({[`posicao${i}`]:{texto:null,pontos:null}})});
/*
        if(retornoPaginacao.length) {
             
            
              setTimeout(() => {
                //    this.setState({
                //                     posicao0:(retornoPaginacao[0]?{texto:retornoPaginacao[0].tim_tur_texto,pontos:retornoPaginacao[0].tim_tur_pontuacao}:{texto:null,pontos:null}),
                //                     posicao1:(retornoPaginacao[1]?{texto:retornoPaginacao[1].tim_tur_texto,pontos:retornoPaginacao[1].tim_tur_pontuacao}:{texto:null,pontos:null}),
                //                     posicao2:(retornoPaginacao[2]?{texto:retornoPaginacao[2].tim_tur_texto,pontos:retornoPaginacao[2].tim_tur_pontuacao}:{texto:null,pontos:null}),
                //                     posicao3:(retornoPaginacao[3]?{texto:retornoPaginacao[3].tim_tur_texto,pontos:retornoPaginacao[3].tim_tur_pontuacao}:{texto:null,pontos:null}),
                //                     posicao4:(retornoPaginacao[4]?{texto:retornoPaginacao[4].tim_tur_texto,pontos:retornoPaginacao[4].tim_tur_pontuacao}:{texto:null,pontos:null}),
                //                     posicao5:(retornoPaginacao[5]?{texto:retornoPaginacao[5].tim_tur_texto,pontos:retornoPaginacao[5].tim_tur_pontuacao}:{texto:null,pontos:null}),
                //                     setTempo:10000
                                
                //                  }) 

                retornoPaginacao.map((elem,i)=>{
                 //   $('.feed_'+i).attr('style',`opacity:0.2`);
                    setTimeout(() => {

                        $('.feed_'+i).attr('style',`opacity:0.2`);
                        const posicao = `posicao${i}`;
                        this.setState({[posicao]:{texto:elem.tim_tur_texto,pontos:elem.tim_tur_pontuacao}});
                        $('.feed_'+i).attr('style',`opacity:0.8`);
     
                    }, 1000 *i);
                });

                //this.renderEfeitoTimeline('0.8');
                this.state.pagination++;
                }, 5000);
                const contLisTimeLine = this.props.timeline.length;
                //this.setState({stopTimeline:(contLisTimeLine <=6 ? true:false)});

            }else {              
               this.state.pagination =1;
            }
*/
    }


    render() {
     
        const opa = {'opacity':'0'}
        return (
            <div className="feeds feed-small">
                        <div className="feeds-columns">
                            <div className="feeds-column">
                                <div className="feed" style={opa}></div>
                                <div className="feed active"></div>
                                <div className="feed feed_1">
                                    <div className="feed-body">
                                        <div className="feed-body-text feed-body-text-white">
                                           {this.state.posicao2.texto}
                                        </div>
                                        <div className="feed-body-points">
                                            <div className="feed-body-points-value">
                                            {this.state.posicao2.pontos}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="feeds-column">
                                <div className="feed feed_2">
                                    <div className="feed-body">
                                        <div className="feed-body-text feed-body-text-white">
                                        {this.state.posicao0.texto}
                                        </div>
                                        <div className="feed-body-points">
                                            <div className="feed-body-points-value">
                                            {this.state.posicao0.pontos}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="feed feed_3">
                                    <div className="feed-body">
                                        <div className="feed-body-text feed-body-text-white">
                                        {this.state.posicao1.texto}
                                        </div>
                                        <div className="feed-body-points">
                                            <div className="feed-body-points-value">
                                            {this.state.posicao1.pontos}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="feed"></div>
                            </div>
                            <div className="feeds-column">
                                <div className="feed no-right"></div>
                                <div className="feed only-right-bottom"></div>
                                <div className="feed"></div>
                            </div>
                        </div>
                        <div className="feeds-columns feeds-hide-1024">
                            <div className="feeds-column">
                                <div className="feed active"></div>
                                <div className="feed only-left-top"></div>
                            </div>
                            <div className="feeds-column">
                                <div className="feed feed_4">
                                    <div className="feed-body">
                                        <div className="feed-body-text feed-body-text-white">
                                        {this.state.posicao4.texto}
                                        </div>
                                        <div className="feed-body-points">
                                            <div className="feed-body-points-value">
                                            {this.state.posicao4.pontos}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="feed feed_5">
                                    <div className="feed-body">
                                        <div className="feed-body-text feed-body-text-white">
                                        {this.state.posicao3.texto}
                                        </div>
                                        <div className="feed-body-points">
                                            <div className="feed-body-points-value">
                                            {this.state.posicao3.pontos}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="feeds-column">
                                <div className="feed feed_6">
                                    <div className="feed-body">
                                        <div className="feed-body-text feed-body-text-white">
                                        {this.state.posicao5.texto}
                                        </div>
                                        <div className="feed-body-points">
                                            <div className="feed-body-points-value">
                                            {this.state.posicao5.pontos}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="feed"></div>
                            </div>
                        </div>
                    </div>
        );
    }
}

function mapStateToProps(state){

    return {
            session: state.auth.session,
            menu: state.configReducer.menu,
            timeline: state.timelineReducer.all_time_home,
           }

}

export default connect(mapStateToProps, { GetTimeLineHome})(feeds);



// WEBPACK FOOTER //
// ./src/components/aluno/home/feeds.js